import React, { Component } from 'react'
import { Button, Drawer, Form, Select } from 'antd';
import Swal from "sweetalert2";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class EditUserLevel extends Component {
    constructor(props) {
        super(props);
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };

    levelHandler = () => {
        if (this.props.data.level_page_limited == null) {
            this.props.changeState({
                level_page_limited: []
            })
        } else {
            this.props.changeState({
                level_page_limited: null
            })
        }
    }

    divisiHandler = () => {
        if (this.props.data.level_divisi_limited == null) {
            this.props.changeState({
                level_divisi_limited: []
            })
        } else {
            this.props.changeState({
                level_divisi_limited: null
            })
        }
    }

    actionHandler = () => {
        if (this.props.data.level_action_limited == null) {
            this.props.changeState({
                level_action_limited: []
            })
        } else {
            this.props.changeState({
                level_action_limited: null
            })
        }
    }

    handleEdit = () => {
        let form = {
            id: this.props.data.level_id,
            level_name: this.props.data.level_name,
            level_page_limited: this.props.data.level_page_limited,
            level_divisi_limited: this.props.data.level_divisi_limited,
            level_action_limited: this.props.data.level_action_limited,
        }
        this.props.request("userlevel/update", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    this.setState({
                        level_id: ''
                    }, () => this.props.changeState({
                        visable: false,
                        level_id: '',
                        level_name: '',
                        level_page_limited: '',
                        level_divisi_limited: '',
                        level_action_limited: '',
                        data: [],
                        isLoading: true,
                    }, () => {
                        this.props.loadData()
                    }))
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }
                if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }


    render() {
        const { Option } = Select;
        return (
            <Modal size="lg" zIndex={999} isOpen={this.props.data.visable} toggle={() => {
                this.props.changeState({ visable: false, p_user_name: '' });
            }}>
                <ModalHeader toggle={() => {
                    this.props.changeState({ visable: false });
                }}>Edit User Level</ModalHeader>
                <ModalBody>
                    <div className="">
                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideLevelName",
                                        title: "Nama Level",
                                        content: "Masukkan nama level user. Nama ini digunakan untuk membedakan hak akses antar role di sistem."
                                    });
                                }}
                            >
                                <label>Nama Level</label>
                                <input
                                    name="level_name"
                                    className="form-control col-xl-12 col-md-12"
                                    placeholder="Nama User..."
                                    type="text"
                                    required=""
                                    value={this.props.data.level_name}
                                    onChange={(event) => {
                                        const target = event.target;
                                        const value = target.value;
                                        const name = target.name;
                                        this.props.changeState({
                                            [name]: value
                                        });
                                    }}
                                />
                            </div>
                        </Form>

                        <Form layout="vertical" hideRequiredMark>
                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideAksesHalaman",
                                        title: "Akses Halaman Level User",
                                        content: "Atur halaman apa saja yang dapat diakses oleh level ini. Centang seluruh akses halaman untuk memberikan akses penuh, atau pilih halaman tertentu jika ingin dibatasi."
                                    });
                                }}
                            >
                                <label>Akses Halaman Level User</label><br />
                                <label
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesHalamanSemua",
                                            title: "Seluruh Akses Halaman",
                                            content: "Aktifkan opsi ini jika level user boleh mengakses semua halaman tanpa pembatasan."
                                        });
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={this.props.data.level_page_limited === null}
                                        onChange={() => this.levelHandler()}
                                    />
                                    &nbsp;Seluruh Akses Halaman
                                </label>

                                {this.props.data.level_page_limited !== null &&
                                    <div
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guidePilihAksesHalaman",
                                                title: "Pilih Akses Halaman",
                                                content: "Pilih satu atau beberapa halaman yang boleh diakses oleh level user ini."
                                            });
                                        }}
                                    >
                                        <Select
                                            name="level_page_limited"
                                            style={{ width: '100%' }}
                                            mode={"multiple"}
                                            placeholder="Pilih Akses Halaman"
                                            value={this.props.data.level_page_limited}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onChange={(event) => {
                                                this.props.changeState({
                                                    level_page_limited: event
                                                })
                                            }}
                                            options={this.props.levelOption}
                                        >
                                        </Select>
                                    </div>
                                }
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideAksesDivisi",
                                        title: "Akses Divisi Karyawan",
                                        content: "Atur divisi karyawan yang dapat dikelola atau dilihat oleh level user ini. Bisa semua divisi atau hanya divisi tertentu."
                                    });
                                }}
                            >
                                <label>Akses Divisi Karyawan</label><br />
                                <label
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesDivisiSemua",
                                            title: "Seluruh Akses Divisi",
                                            content: "Aktifkan opsi ini jika level user boleh mengakses seluruh divisi karyawan."
                                        });
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={this.props.data.level_divisi_limited === null}
                                        onChange={() => this.divisiHandler()}
                                    />
                                    &nbsp;Seluruh Akses Divisi
                                </label>

                                {this.props.data.level_divisi_limited !== null &&
                                    <div
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guidePilihAksesDivisi",
                                                title: "Pilih Akses Divisi",
                                                content: "Pilih satu atau beberapa divisi yang boleh diakses oleh level user ini."
                                            });
                                        }}
                                    >
                                        <Select
                                            name="level_divisi_limited"
                                            style={{ width: '100%' }}
                                            mode={"multiple"}
                                            placeholder="Pilih Akses Divisi"
                                            value={this.props.data.level_divisi_limited}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onChange={(event) => {
                                                this.props.changeState({
                                                    level_divisi_limited: event
                                                })
                                            }}
                                        >
                                            {this.props.data.divisi.map((item, index) => {
                                                return (
                                                    <Option value={item.divisi_id} key={item.divisi_id}>
                                                        {item.divisi_name}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    </div>
                                }
                            </div>

                            <div
                                className="form-group"
                                onPointerEnter={(e) => {
                                    this.triggerGuideOnce(e, {
                                        key: "guideAksesAksi",
                                        title: "Akses Aksi Level User",
                                        content: "Atur jenis aksi yang diizinkan untuk level user ini, seperti tambah, lihat, ubah, atau hapus data."
                                    });
                                }}
                            >
                                <label>Akses Aksi Level User</label><br />
                                <label
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesAksiSemua",
                                            title: "Seluruh Akses Aksi",
                                            content: "Aktifkan opsi ini jika level user boleh menggunakan seluruh aksi yang tersedia di sistem."
                                        });
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={this.props.data.level_action_limited === null}
                                        onChange={() => this.actionHandler()}
                                    />
                                    &nbsp;Seluruh Akses Aksi
                                </label>

                                {this.props.data.level_action_limited !== null &&
                                    <div
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guidePilihAksesAksi",
                                                title: "Pilih Akses Aksi",
                                                content: "Pilih aksi yang boleh dilakukan oleh level user. Jika memilih Ubah atau Hapus, sistem otomatis menambahkan akses Lihat."
                                            });
                                        }}
                                    >
                                        <Select
                                            name="level_action_limited"
                                            style={{ width: '100%' }}
                                            mode={"multiple"}
                                            placeholder="Pilih Akses Aksi"
                                            value={this.props.data.level_action_limited}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            onChange={(selectedValues) => {
                                                let updatedValues = selectedValues;
                                                if (selectedValues.includes('U') || selectedValues.includes('D')) {
                                                    updatedValues = Array.from(new Set([...selectedValues, 'R']));
                                                }

                                                this.props.changeState({
                                                    level_action_limited: updatedValues
                                                });
                                            }}
                                            options={[
                                                { label: 'Create (Tambah Data)', value: 'C' },
                                                { label: 'Read (Lihat Data)', value: 'R' },
                                                { label: 'Update (Ubah Data)', value: 'U' },
                                                { label: 'Delete (Hapus Data)', value: 'D' },
                                            ]}
                                        >
                                        </Select>
                                    </div>
                                }
                            </div>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button
                            onClick={() => {
                                this.setState({ level_name: '' });
                                this.props.changeState({ visable: false });
                            }}
                            style={{marginRight: 8}}>
                            Batal
                        </Button>
                        <Button onClick={this.handleEdit} type="primary">
                            Simpan
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default withTourGuide(EditUserLevel)